import { h, Component } from "preact";
import { Field, FieldArray } from "redux-form";
import InputField from "../../../components/fields/InputField";
import DateField from "../../../components/fields/DateField";
import OptionsField from "../../../components/fields/OptionsField";
import MultipleOptionsField from "../../../components/fields/MultipleOptionsField";
import TextareaField from "../../../components/fields/TextareaField";
import CheckboxField from "../../../components/fields/CheckboxField";
import NoteField from "../../../components/fields/NoteField";
import ImageUploadField from "../../../components/fields/ImageUploadField";
import TermsAndConditionsField from "../../../components/fields/TermsAndConditionsField";
import LocationField from "../../../components/fields/LocationField";
import { required } from "../../../utils/Validators";
import { addQuestionQuantityCheck } from "./AdditionalQuestionQuantityValidator";
import { checkCondition, checkOrderQuestionCondition } from "./CheckCondition";
/**
 * Display form field based on conditions
 *
 * @param {object, string, object, object, objectId, boolean, function} { question, formName, orderAdditionalQuestions, ticketsAdditionalQuestions, ticketId, disabled, changeFieldValue }
 * @returns redux form
 */
const ConditionalQuestion = ({
  question,
  formName,
  orderAdditionalQuestions,
  ticketsAdditionalQuestions,
  ticketId,
  disabled,
  changeFieldValue
}) => {
  const isBrowser = typeof window !== "undefined";
  let isSafari = false;
  if (isBrowser) {
    isSafari =
      /constructor/i.test(window.HTMLElement) ||
      (function(p) {
        return p.toString() === "[object SafariRemoteNotification]";
      })(
        !window["safari"] ||
          (typeof safari !== "undefined" && safari.pushNotification)
      );
  }
  const trackQuantity = question.trackQuantity ? question.trackQuantity : false;
  let RenderField =
    question.inputType === "date" && isSafari ? DateField : InputField;

  switch (question.type) {
    case "options":
      RenderField = OptionsField;
      break;
    case "multiSelect":
      RenderField = MultipleOptionsField;
      break;
    case "textarea":
      RenderField = TextareaField;
      break;
    case "checkbox":
      RenderField = CheckboxField;
      break;
    case "image":
      RenderField = ImageUploadField;
      break;
    case "terms":
      RenderField = TermsAndConditionsField;
      break;
    case "note":
      RenderField = NoteField;
      break;
    case "address":
      RenderField = LocationField;
      break;
  }
  const defaultValue = question.defaultValue || "";
  const rename = question.rename || "";
  let conditionalQuestion;

  if (question.type === "address") {
    conditionalQuestion = (
      <FieldArray
        label={question.question}
        description={question.description}
        type={question.type}
        questionName={question.name}
        name={`${question.name}-${question.type}`}
        inputType={question.inputType}
        trackQuantity={trackQuantity}
        component={RenderField}
        formName={formName}
        defaultValue={defaultValue}
        rename={rename}
        disabled={disabled}
        aspectRatio={1}
        options={question.options}
        settings={question.settings}
        required={question.required}
        valueField="label"
        placeholder=""
        changeFieldValue={changeFieldValue}
        addQuestionQuantityCheck={addQuestionQuantityCheck(question)}
      />
    );
  } else {
    conditionalQuestion = (
      <Field
        label={question.question}
        description={question.description}
        type={question.type}
        name={question.name}
        inputType={question.inputType}
        trackQuantity={trackQuantity}
        component={RenderField}
        formName={formName}
        defaultValue={defaultValue}
        rename={rename}
        disabled={disabled}
        aspectRatio={1}
        options={question.options}
        settings={question.settings}
        required={question.required}
        valueField="label"
        placeholder=""
        changeFieldValue={changeFieldValue}
        validate={
          question.required
            ? [required, addQuestionQuantityCheck(question)]
            : [addQuestionQuantityCheck(question)]
        }
      />
    );
  }
  if (
    checkOrderQuestionCondition(question, orderAdditionalQuestions) ||
    (ticketId !== "" &&
      checkCondition(question, ticketsAdditionalQuestions, ticketId))
  ) {
    return conditionalQuestion;
  }
};

/**
 * Display additional questions for order and tickets
 *
 * @class AdditionalQuestion
 * @extends {Component}
 */
class AdditionalQuestion extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {
      question,
      ticketAdditionalFields = [],
      ticketId = "",
      ticketsAdditionalQuestions = {},
      orderAdditionalQuestions = {},
      orderAdditionalFields = [],
      formName = "details",
      disabled = false,
      changeFieldValue
    } = this.props;
    ticketAdditionalFields.length > 0 &&
      ticketId !== "" &&
      ticketAdditionalFields.forEach(field => {
        ticketsAdditionalQuestions[ticketId] =
          ticketsAdditionalQuestions[ticketId] || {};
        ticketsAdditionalQuestions[ticketId][field.questionId] =
          ticketsAdditionalQuestions[ticketId][field.questionId] || field.value;
      });
    orderAdditionalFields.length > 0 &&
      orderAdditionalFields.forEach(field => {
        if (field && field.questionId)
          orderAdditionalQuestions[field.questionId] =
            orderAdditionalQuestions[field.questionId] || field.value;
      });

    return (
      <ConditionalQuestion
        question={question}
        formName={formName}
        ticketsAdditionalQuestions={ticketsAdditionalQuestions}
        ticketId={ticketId}
        orderAdditionalQuestions={orderAdditionalQuestions}
        disabled={disabled}
        changeFieldValue={changeFieldValue}
      />
    );
  }
}

export default AdditionalQuestion;



// WEBPACK FOOTER //
// ./routes/details/additionalQuestion/AdditionalQuestion.js